module.exports = __webpack_public_path__ + "static/media/triangle-warning-red.7024e9f9.svg";